import { PlayerEvent, PlaybackState } from '@cbsinteractive/avia-js';

export const VideoPreviewEvent = {
    CONTENT_DURATION_AVAILABLE: PlayerEvent.CONTENT_DURATION_AVAILABLE,
    CONTENT_START: PlayerEvent.CONTENT_START,
    ENDED: PlayerEvent.RESOURCE_END,
    ERROR: PlayerEvent.ERROR,
    PLAYBACK_RESUMED: PlayerEvent.PLAYBACK_RESUMED,
    PLAYBACK_STARTED: PlayerEvent.PLAYBACK_STARTED,
    PLAYBACK_STATE_CHANGE: PlayerEvent.PLAYBACK_STATE_CHANGE,
    READY: PlayerEvent.READY,
};

export const VideoPreviewState = {
    PLAYING: PlaybackState.PLAYING,
};
